import { z } from 'zod'
import { rarityEnum } from '../../shared/rarity'
import { mediaItemSchema } from '../../shared/media'
import { successResponseSchema } from '../../shared/success'
import { nonTransferableTypeEnum } from '../../user/assets/transfer/preview/schema'

const convertableAssetSchema = z.object({
  id: z.number(),
  drop_id: z.number(),
  name: z.string(),
  rarity: rarityEnum,
  mint_num: z.number(),
  template_id: z.number(),
  points: z.number(),
  listing_id: z.number().optional(),
  media: z.array(mediaItemSchema)
})

const seasonTotalSchema = z.object({
  rank: z.number(),
  points: z.number()
})

const convertErrorSchema = z.object({
  type: nonTransferableTypeEnum,
  title: z.string(),
  description: z.string(),
  assets: z.array(convertableAssetSchema)
})

export const convertAssetsPreviewResponseSchema = successResponseSchema.extend({
  data: z.object({
    assets: z.array(convertableAssetSchema),
    potential_points: z.number().optional(),
    potential_rank: z.number().optional(),
    errors: z.array(convertErrorSchema)
  })
})

export const convertAssetsResponseSchema = successResponseSchema.extend({
  data: z.object({
    assets: z.array(convertableAssetSchema),
    errors: z.array(convertErrorSchema),
    converted_asset_ids: z.array(z.number()),
    season_total: seasonTotalSchema
  })
})

export type ConvertableAsset = z.infer<typeof convertableAssetSchema>
export type ConvertAssetsResponse = z.infer<typeof convertAssetsResponseSchema>
export type ConvertError = z.infer<typeof convertErrorSchema>
export type ConvertAssetsPreviewResponse = z.infer<
  typeof convertAssetsPreviewResponseSchema
>
